import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'

export default () => {
    const { response: { query }} = useAppState()

    return (
        <div class="ns-text-align-center ns-my-5 ns-mx-0">
            <div class="ns-font-4">No results found for '{query}'</div>
        </div>
    )
}
